<app-modal [header]="'Visualizar'"
  [isShow]="displayModal"
  [style]="'w-full max-w-lg z-index-50'"
  (cancel)="displayModal = false; onCancelModalEmitter.emit()">

  <div class="grid grid-cols-2 sm:grid-cols-1">
    <!-- image -->
    <div class="bg-gray-100 p-4">
      <app-image [event]="this.event"></app-image>
    </div>

    <!-- ocurrence details -->
    <div class="col-span-1">
      <div class="p-10">

        <!-- title and description -->
        <div class="flex justify-between">
          <h2 class="text-2xl font-bold text-gray-800 md:text-3xl">{{this.event?.title}}</h2>
        </div>

        <p class="my-8 text-gray-600 text-sm">{{this.event.description}}</p>

        <!-- Information header-->
        <div class=" flex space-x-2  mt-4 mb-2 text-gray-700">
          <div><i class="pi pi-id-card" style="font-size: 1.5rem"></i></div>
          <h1 class=" font-bold tracking-wide">informações</h1>
        </div>

        <!-- event details left -->
        <div class="space-y-2 text-sm">

          <!-- referencia -->
          <p>Referência: {{ event.reference}}</p>

          <!-- if people -->
          @if (event.category.code === 'PEOPLE') {
            <!--gender birthdate-->
            <p><span>Genero/Data de Nascimento: Masculino/28-01-1995</span>
            <p>
              <span>Conhecidos:  {{!event.personFilter.names ? notInformedText : event.personFilter.names | titlecase}}</span>
            </p>
          }

          <!-- if vehicle -->
          @if (event.category.code === 'VEHICLE') {
            <p>Marca & Modelo: {{event.vehicleFilter.brand + ', ' + event.vehicleFilter.model}}</p>
            <p>Matricula: {{event.vehicleFilter.licensePlate}}</p>
            <p>Chassi: {{event.vehicleFilter.chassiNumber ?? notInformedText}}</p>
          }

          <!-- if document -->
          @if (event.category.code === 'DOCUMENT') {
            <div>
              <p>Tipo de
              documento: {{!event.documentFilter.type?.description ? notInformedText : event.documentFilter.type.description | titlecase}}</p>
              <p>Entidade
              emissora: {{!event.documentFilter.entity ? notInformedText : event.documentFilter.entity | titlecase}}</p>
            </div>
          }

          <!-- if other -->
          @if (event.category.code === 'DOCUMENT' || event.category.code === 'OTHER') {
            <p>Identificação: {{event.identification ? event.identification : notInformedText}} </p>
          }

          <p class="space-y-2 text-sm">
          Local: {{this.event.province.description | titlecase }}{{', ' + event.eventDate}} </p>

          <ng-container class="space-y-2 text-sm">
            <p> Contacto:

              <!-- add the number -->
              <span class="font-bold"> {{this.event.contact}} </span>
            </p>
          </ng-container>

          <p>Reportado por: {{this.event.account.firstname + ' ' + this.event.account.lastname}}</p>
          <p>Recompensa: {{this.event?.reward ?? notInformedText}}</p>
        </div>
      </div>
    </div>
  </div>

</app-modal>

